import type { TenantBrand } from '@tendedloop/shared';
import { bandColors } from '@tendedloop/shared/brand-colors';
import type { PortalLang } from '@/lib/lang';
import { HOME_STRINGS } from './homeStrings';

/**
 * What living here includes: the brand kit's features (label + line icon) on
 * the brand's band colour, the way the brand's own posts set them (icons drawn
 * for black on black). Shown on home for a verified brand that lists features;
 * nothing otherwise.
 */
export function WhatsIncluded({ brand, lang = 'he' }: { brand: TenantBrand | null; lang?: PortalLang }) {
  const features = brand?.features ?? [];
  if (!brand || !features.length) return null;
  const band = bandColors(brand.logoBackground);
  return (
    <section
      aria-labelledby="included-title"
      className={'mt-6 rounded-2xl px-4 pb-5 pt-4' + (band.light ? ' border border-slate-200' : '')}
      style={{ backgroundColor: band.bg, color: band.fg }}
    >
      <h2 id="included-title" className="text-[17px] font-bold">
        {HOME_STRINGS[lang].included}
      </h2>
      <ul className="mt-4 grid gap-2" style={{ gridTemplateColumns: `repeat(${features.length}, minmax(0, 1fr))` }}>
        {features.map((f) => (
          <li key={f.label} className="flex flex-col items-center gap-2 text-center text-[16px] leading-snug">
            {f.iconUrl && <img src={f.iconUrl} alt="" aria-hidden className="h-12 w-12" />}
            {f.label}
          </li>
        ))}
      </ul>
    </section>
  );
}
